import { render, staticRenderFns } from "./admin_pk_version.vue?vue&type=template&id=6bf29ad7&scoped=true&"
import script from "./admin_pk_version.vue?vue&type=script&lang=ts&"
export * from "./admin_pk_version.vue?vue&type=script&lang=ts&"
import style0 from "./admin_pk_version.vue?vue&type=style&index=0&id=6bf29ad7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf29ad7",
  null
  
)

export default component.exports